var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowNext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.644 8.5 2.79 15.354l-.707-.707L8.229 8.5 2.083 2.354l.707-.708zm-2.01-6.854-.707.708L13.073 8.5l-6.146 6.146.707.707L14.487 8.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-next.svg";